import * as ActionTypes from './actionType.js';


const reducerMap = {
    /**
     * 获得题目列表
     * **/
    [ActionTypes.setQuestionList]: (state, payload) => {
        return Object.assign({}, state, {
            questionList:payload.data,
        });
    },
    [ActionTypes.setQuestionListShopcar]: (state, payload) => {
        return Object.assign({}, state, {
            questionListShopcar:payload.data,
        });
    },
    [ActionTypes.setShopcar]: (state, payload) => {
        return Object.assign({}, state, {
            shopcar:payload.data
        });
    },

    [ActionTypes.setTypeList]: (state, payload) => {
        return Object.assign({}, state, {
            typeList:payload.data
        });
    },
    [ActionTypes.setAssistList]: (state, payload) => {
        return Object.assign({}, state, {
            assistList:payload.data
        });
    },
    [ActionTypes.setTreeList]: (state, payload) => {
        return Object.assign({}, state, {
            treeList:payload.data,
            product:payload.product
        });
    },
    [ActionTypes.setExpandedKeys]: (state, payload) => {
        return Object.assign({}, state, {
            expandedKeys:payload.data
        });
    },
    [ActionTypes.setDefaultAssistList]: (state, payload) => {
        return Object.assign({}, state, {
            defaultAssistList:payload.data
        });
    },
    [ActionTypes.setSelectedKeys]: (state, payload) => {
        return Object.assign({}, state, {
            selectedKeys:payload.data
        });
    },




}
export const INITIALIZE_STATE = {
    questionList: {
        total:1,
        difficult: [],
        questiontype:[],
        systemtype:[],
        list:[],
        hot:[],
        onlinestatus:[],
        rightrate:[]
    },
    questionListShopcar: {
        total:1,
        list:[],
    },
    shopcar:[],
    typeList:{},
    assistList:{},
    treeList:{},
    product:'',
    setSelectedKeys:[],
}
export default (state = INITIALIZE_STATE, action = {}) => {
    const { type, payload } = action;
    const reducer = reducerMap[type];
    if (reducer) {
        return reducer(state, payload);
    } else {
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/look_over_question/reducer.js